import { render } from "./InfographicCard.vue?vue&type=template&id=42ac1c40"
import script from "./InfographicCard.vue?vue&type=script&lang=js"
export * from "./InfographicCard.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__